import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Document } from '@/model/document2/document';

// ドキュメントの回転コマンド
export class RotateDocumentCommand implements ICommandBase
{
    private document! : Document;
    private delta! : number;
    private doneCallback! : () => void;

    constructor(document : Document, delta : number, doneCallback : () => void)
    {
        this.document = document;
        this.delta = delta;
        this.doneCallback = doneCallback;
    }

    public do() : void
    {
        // ドキュメントを回転
        this.document.rotateDocument(this.delta);
        
        this.doneCallback();
    }

    public undo() : void
    {
        // ドキュメントを逆回転
        this.document.rotateDocument(-this.delta);

        this.doneCallback();
    }

    public redo() : void
    {
        // ドキュメントを回転
        this.document.rotateDocument(this.delta);

        this.doneCallback();
    }
}
